import React, { Component } from 'react'
import {
  CLOUDINARY_API_KEY,
  CLOUDINARY_NAME,
} from '../../../../constants/images/cloudinary'
import {
  SEARCH_IMAGE_PARAMS,
  USER_SMALL_PARAMS,
} from '../../../../constants/images/sizesAndQuality'
import {
  convertCents,
  makeTitleCase,
  buildBikeURL,
  buildDatesForUrl,
} from '../../../utils'
import cloudinary from 'cloudinary-core'
import Slider from 'react-slick'
import MagicSliderDots from 'react-magic-slider-dots'
import { Link } from 'react-router-dom'
import RatingStars from '../../../elements/ratingStars'
import NumberFormat from 'react-number-format'
import getSymbolFromCurrency from 'currency-symbol-map'
import { findMultidayPrice } from '../searchUtil.js'
const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_NAME,
  api_key: CLOUDINARY_API_KEY,
})

function NextArrow(props) {
  const { onClick } = props
  return (
    <i className="twisted-map-next fal fa-angle-right" onClick={onClick}></i>
  )
}

function PrevArrow(props) {
  const { onClick } = props
  return (
    <i className="twisted-map-prev fal fa-angle-left" onClick={onClick}></i>
  )
}

const SingleListing = ({ info, startDate, endDate }) => {
  return (
    <div className="pop-up-multiple-owners">
      <Link
        to={
          buildBikeURL({
            country: info[0].bike_location.country_abbreviation,
            region: info[0].bike_location.region_abbreviation,
            city: info[0].bike_location.city,
            year: info[0].bike_year.toString(),
            make: info[0].bike_make,
            model: info[0].bike_model,
            bikeID: info[0].bike_id,
          }) + buildDatesForUrl(startDate, endDate)
        }
        target="_blank"
      >
        <img
          src={cl.url(
            info[0].bike_image_cloudinary_public_id,
            SEARCH_IMAGE_PARAMS
          )}
          alt={
            info[0].bike_year +
            ' ' +
            info[0].bike_make +
            ' ' +
            info[0].bike_model
          }
        />
        <div className="single-listing-map-content">
          <span className="marker-bike-category">
            {makeTitleCase(info[0].bike_category)}
          </span>
          <span className="marker-bike-title">
            {info[0].bike_year} {info[0].bike_make} {info[0].bike_model}
          </span>
          <span className="marker-bike-pricing">
            <NumberFormat
              defaultValue={convertCents(
                findMultidayPrice(info[0], startDate, endDate)
              )}
              displayType={'text'}
              thousandSeparator={true}
              prefix={getSymbolFromCurrency(info[0].day_price_currency)}
            />
            / per day
          </span>
          <span className="marker-bike-ratings">
            <RatingStars
              rating={info[0].average_rating}
              ratingCount={info[0].ratings_count}
            />
          </span>
        </div>
      </Link>
    </div>
  )
}

const MultiListing = ({ info, startDate, endDate }) => {
  var topSliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    //asNavFo : this.state.nav2,
    //ref: slider => (this.slider1 = slider),
    appendDots: (dots) => {
      return <MagicSliderDots dots={dots} numDotsToShow={5} dotWidth={30} />
    },
  }

  return (
    <React.Fragment>
      <div className="multiple-listings-map-header">
        <img
          height="1rem"
          width="1rem"
          className="is-avatar"
          src={cl.url(info[0].bike_owner_avatar_id, USER_SMALL_PARAMS)}
          alt={info[0].bike_owner_first_name}
        />
        {info[0].bike_owner_first_name}'s listings
        <br />
      </div>
      <Slider {...topSliderSettings}>
        {info.map((subinfo, index) => (
          <div className="pop-up-multiple-owners" key={index}>
            <Link
              to={
                buildBikeURL({
                  country: subinfo.bike_location.country_abbreviation,
                  region: subinfo.bike_location.region_abbreviation,
                  city: subinfo.bike_location.city,
                  year: subinfo.bike_year.toString(),
                  make: subinfo.bike_make,
                  model: subinfo.bike_model,
                  bikeID: subinfo.bike_id,
                }) + buildDatesForUrl(startDate, endDate)
              }
              target="_blank"
            >
              <img
                src={cl.url(
                  subinfo.bike_image_cloudinary_public_id,
                  SEARCH_IMAGE_PARAMS
                )}
                alt={
                  subinfo.bike_year +
                  ' ' +
                  subinfo.bike_make +
                  ' ' +
                  subinfo.bike_model
                }
              />
              <div className="multiple-listings-map-content">
                <span className="marker-bike-category">
                  {makeTitleCase(subinfo.bike_category)}
                </span>
                <span className="marker-bike-title">
                  {subinfo.bike_year} {subinfo.bike_make} {subinfo.bike_model}
                </span>
                <span className="marker-bike-pricing">
                  <NumberFormat
                    defaultValue={convertCents(
                      findMultidayPrice(subinfo, startDate, endDate)
                    )}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={getSymbolFromCurrency(subinfo.day_price_currency)}
                  />
                  / per day
                </span>
                <span className="marker-bike-ratings">
                  <RatingStars
                    rating={subinfo.average_rating}
                    ratingCount={subinfo.ratings_count}
                  />
                </span>
              </div>
            </Link>
          </div>
        ))}
      </Slider>
    </React.Fragment>
  )
}

class MapMarkerContent extends Component {
  render() {
    const { info, startDate, endDate } = this.props
    return (
      <div className="map-listing-popup-wrapper">
        {info.length === 1 && (
          <SingleListing info={info} startDate={startDate} endDate={endDate} />
        )}
        {info.length > 1 && (
          <MultiListing info={info} startDate={startDate} endDate={endDate} />
        )}
      </div>
    )
  }
}
export default MapMarkerContent
MapMarkerContent.defaultProps = {
  info: null,
  startDate: null,
  endDate: null,
}
